import { inject, Injectable } from '@angular/core';
import { UseCaseGet } from '@shared/helper';
import { GetRoamingPageDataResp } from './get-roaming-page-data.type';
import { RoamingRepository } from '@data/repositories/roaming.repository';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class GetRoamingPageDataUsecase implements UseCaseGet<GetRoamingPageDataResp> {
    roamingRepository = inject(RoamingRepository);

    execute(): Observable<GetRoamingPageDataResp> {
        return this.roamingRepository.GetRoamingPageData();
    }
}